import * as React from 'react';
import { useState } from 'react';
import SteinStore from 'stein-js-client';
import Log from '../../lib/log';

// ログの初期化
const log = new Log('TermsDetail');

const getTerms = async () => {
  try {
    // 利用規約をGoogle Sheetsから読み込む
    // https://docs.google.com/spreadsheets/d/1-lWeALvURBybOvqU6sxzraNznmeCEpugZMBKOGjY-NI/edit#gid=0
    const store = new SteinStore(
      'https://api.steinhq.com/v1/storages/62d21bc04906bb053753fc01',
    );
    const terms = await store.read('terms');
    let output: string = '';
    terms.map((row: any) => {
      if (row['条項']) {
        output += `
        <h3>
        ${row['条項']}
        </h3>
        `;
      }
      output += `
      <p>
      ${row['内容']}
      </p>
      `;
      return true;
    });
    return output;
  } catch (err: any) {
    log.putLog('error', `getTerms error. ${err.message ? err.message : err}`);
  }
};

interface Props {
  handleTermsLoaded: () => void;
}
export default function TermsDetail(props: Props) {
  const [terms, setTerms] = useState<string | undefined>('');
  React.useEffect(() => {
    (async () => {
      const output = await getTerms();
      setTerms(output);
      props.handleTermsLoaded();
    })();
  }, [props]);
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: terms ? terms : '',
      }}
    />
  );
}
